import { VerifiedClient } from '../../../types';

interface RenderClientIDDetailsOptions {
    tableHeaderSize: string;
    tableTextSize: string;
    imageColumnWidth: string;
    imageMaxWidth: string;
}

function getDisplayConfig() : RenderClientIDDetailsOptions {
    const tableHeaderSize = '24px';
    const tableTextSize = '16px';
    const imageColumnWidth = '25%';
    const imageMaxWidth = '300px';
    return {
        tableHeaderSize,
        tableTextSize,
        imageColumnWidth,
        imageMaxWidth
    }
}

function isPastTargetDate(){
    const currentYear = new Date().getFullYear();
    return currentYear > 2024;
}

export const renderClientIDDetailsInNewWindow = (verifiedClients: VerifiedClient[], province: string, fileNumber: string) => {
    const { tableHeaderSize, tableTextSize, imageColumnWidth, imageMaxWidth } = getDisplayConfig();
    let htmlContent = `
        <html>
        <head>
            <style>
                body { font-family: Arial, sans-serif; }
                h1 { font-size: ${tableHeaderSize}; margin-bottom: 20px; text-align: center; }
                .container { text-align: center; }
                table { border-collapse: collapse; width: 100%; max-width: 1140px; margin: 10px auto; position: relative; }
                th, td { border: 1px solid #ddd; padding: 8px; font-size: ${tableTextSize};}
                th { background-color: #f2f2f2; }
                .print-button { background-color: #006A99; color: #fff; border: none; padding: 10px 20px; font-size: 16px; cursor: pointer; border-radius: 20px; }
                .download-button { background-color: #006A99; color: #fff; border: none; padding: 10px 20px; font-size: 16px; cursor: pointer; border-radius: 20px; }
                .print-button:hover { background-color: #005780; }
                .reply { margin-left: 20px; }
                @media print { .print-button { display: none; }}
            </style>
        </head>
        <body>
            <h1>Client ID Details for File: ${fileNumber}</h1>
            <div class="container">
                <button class="print-button" onclick="window.print()"> Print</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th style="width: auto" }>Client Details</th>
                        ${ ((isPastTargetDate() && province === "AB") || (province !== 'AB')) ? `<th style="width: auto">Client Fraud Check</th>` : '' }
                        <th style="width: ${imageColumnWidth}"}>Client ID Images</th>
                    </tr>
                </thead>
                <tbody>
    `;

    verifiedClients.forEach((verifiedClient) => {
        htmlContent += `
            <tr>
                <td style="vertical-align: top">
                    <p><strong>Name:</strong> ${verifiedClient.clientInformation.Name}</p>
                    <p><strong>ID Type:</strong> ${verifiedClient.clientInformation.Type}</p>
                    <p><strong>Face Verification Result Passed:</strong> ${verifiedClient.FaceVerificationPassed ? 'Yes' : 'No'}</p>
                ${ ((isPastTargetDate() && province === "AB") || (province !== 'AB')) ?
                `<td style="vertical-align: top">
                    <p><strong>Certainty:</strong> ${verifiedClient.clientIdFraudCheck.certainty === 'NotPerformed' ? 'Low' : verifiedClient.clientIdFraudCheck.certainty}</p>
                    <p><strong>Score:</strong> ${verifiedClient.clientIdFraudCheck.score}</p>
                    <p><strong>Failed Checks:</strong> ${verifiedClient.clientIdFraudCheck.failedChecks}</p>
                    <p><strong>Checks not performed:</strong> ${verifiedClient.clientIdFraudCheck.notPerformedChecks}</p>
                    <p><strong>Passed Checks:</strong> ${verifiedClient.clientIdFraudCheck.passedChecks}</p>
                    <p><strong>Total Checks:</strong> ${verifiedClient.clientIdFraudCheck.totalChecks}</p>
                </td>` : '' }
                <td style="text-align: center;">
                    ${verifiedClient.clientIDImages.frontImage ?
                        `<p> 
                                <img src="${verifiedClient.clientIDImages.frontImage}" alt="Not Available" style="max-width: ${imageMaxWidth};">
                        </p>` : `<p> Front Image Not Available </p>`}
                    ${verifiedClient.clientIDImages.backImage ?
                        `<p>
                                <img src="${verifiedClient.clientIDImages.backImage}" alt="Not Available" style="max-width: ${imageMaxWidth};">
                        </p>` : `<p> Back Image Not Available </p>`}
                </td>
            </tr>
        `;
    });

    htmlContent += `
                </tbody>
            </table>
        </body>
        </html>
    `;

    const clientIDDetailsWindow = window.open(' ', '_blank');
    if (clientIDDetailsWindow) {
        clientIDDetailsWindow.document.write(htmlContent);
        clientIDDetailsWindow.document.close();
        clientIDDetailsWindow.print();
    } 
    else {
        alert('Allow pop-ups to open the client ID details in a new window.');
    }
}      